// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "配电自动化",
      "tec": "孙天贺",
      "week": "1-8周",
      "add": "教学楼A座322电力"
    },
    {
      "sub": "电气CAD",
      "tec": "李艳",
      "week": "4-11周",
      "add": "实训楼C座103"
    },
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "电网规划与设计",
      "tec": "谢洪放钟丹田",
      "week": "1-8周",
      "add": "教学楼C座115教务"
    },
    0,
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "电力系统自动化",
      "tec": "金红洋",
      "week": "1-8周",
      "add": "教学楼C座115教务"
    },
    {
      "sub": "二次回路",
      "tec": "马仕海",
      "week": "1-8周",
      "add": "教学楼C座115教务"
    },
    0,
    0,
    0
  ],
  "4": [
    0,
    {
      "sub": "电网规划与设计",
      "tec": "谢洪放钟丹田",
      "week": "1,3,5,7周",
      "add": "教学楼C座113教务"
    },
    {
      "sub": "电气CAD",
      "tec": "李艳",
      "week": "4-11周",
      "add": "实训楼C座103"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "二次回路",
      "tec": "马仕海",
      "week": "1-8周",
      "add": "教学楼C座214教务"
    },
    {
      "sub": "电力系统自动化",
      "tec": "金红洋",
      "week": "2,4,6,8周",
      "add": "教学楼C座210教务"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
